import styles from '../styles.module.scss';
import { Button, FormGroup } from '@starsoft/common/components';
import { CoinType } from '@starsoft/common/models';
import skeleton from './styles.module.scss';
import { TransactionModalsWithdrawLayoutFooterSkeletonProps } from './props';
import { WithdrawStep } from '@starsoft/common/enums';
import { TransactionOptions } from '../../../../props';
import Fee from '../../../../Modals/Withdraw/Content/Form/Layout/Fee';

export default function TransactionModalsWithdrawLayoutFooterSkeleton<
  T extends TransactionOptions,
>({
  coinType,
  transactionStep,
}: TransactionModalsWithdrawLayoutFooterSkeletonProps<T>) {
  if ([WithdrawStep.Response].includes(transactionStep as WithdrawStep)) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Fee noChain={coinType == CoinType.Fiat} isLoading />
      <div className={styles.container__divider} />
      <div className={styles.container__row}>
        <FormGroup isLoading>
          <p className={styles.container__value}>
            <div className={skeleton.value} />
          </p>
        </FormGroup>

        <Button isSkeleton />
      </div>
    </div>
  );
}
